import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const RealTimeVisitors = ({ initialCount = 0 }) => {
  const [activeUsers, setActiveUsers] = useState(initialCount);
  const [isLive, setIsLive] = useState(true);

  useEffect(() => {
    if (!isLive) return;

    const interval = setInterval(() => {
      setActiveUsers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        return Math.max(0, prev + change);
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [isLive]);

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="relative">
            <div className="w-3 h-3 bg-success rounded-full"></div>
            <div className="absolute inset-0 w-3 h-3 bg-success rounded-full animate-ping"></div>
          </div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">Real-Time Visitors</h3>
        </div>
        <button
          onClick={() => setIsLive(!isLive)}
          className="text-xs text-muted-foreground hover:text-foreground transition-colors"
        >
          {isLive ? 'Pause' : 'Resume'}
        </button>
      </div>
      
      <div className="flex items-center justify-center py-6 md:py-8">
        <div className="text-center">
          <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-2">
            {activeUsers}
          </div>
          <p className="text-sm md:text-base text-muted-foreground">Active users browsing catalogs</p>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-3 md:gap-4 pt-4 border-t border-border">
        <div className="text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <Icon name="Eye" size={16} className="text-accent" />
            <span className="text-lg md:text-xl font-semibold text-foreground">{Math.floor(activeUsers * 1.8)}</span>
          </div>
          <p className="text-xs text-muted-foreground">Page Views/min</p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <Icon name="MousePointerClick" size={16} className="text-success" />
            <span className="text-lg md:text-xl font-semibold text-foreground">{Math.floor(activeUsers * 0.6)}</span>
          </div>
          <p className="text-xs text-muted-foreground">Clicks/min</p>
        </div>
      </div>
    </div>
  );
};

export default RealTimeVisitors;